module.exports = "<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/baba_frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main